export enum COMPANY_SIZE {
    ONLY_ME = 'only_me',
    TWO_TO_TEN = 'between_2_and_10',
    ELEVEN_TO_FIFTY = 'between_11_and_50',
}

export type BUSINESS_PURPOSE = 'business' | 'side_project' | 'personal';
